import React, { Component } from 'react';
import { generateKey } from '../../utils/utils.js';

const YOUTUBE_ID = /(?:youtube\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;
const VIMEO_ID = /vimeo\.com\/(?:video\/)?(\d+)/i;

class Iframe extends Component {

  render() {
    const raw = this.props.content.content[0].value;
    const autoplay = this.props.autoplay ? 1 : 0;
    let videoLink = null;

    const ytMatch = raw.match(YOUTUBE_ID);
    const vimeoMatch = raw.match(VIMEO_ID);

    if (ytMatch) {
      const params = new URLSearchParams({
        autohide: '1',
        modestbranding: '1',
        rel: '0',
        autoplay: String(autoplay),
        showinfo: '0',
        controls: '1',
      });
      videoLink = `https://www.youtube-nocookie.com/embed/${ytMatch[1]}?${params}`;
    } else if (vimeoMatch) {
      const params = new URLSearchParams({
        autoplay: String(autoplay),
        controls: '0',
        playsinline: '1',
      });
      videoLink = `https://player.vimeo.com/video/${vimeoMatch[1]}?${params}`;
    }

    if (!videoLink) return null;

    return (
      <div key={generateKey(this.props.index)} className="width-full-width iframe--container">
        <iframe
          src={videoLink}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title={videoLink}
        />
      </div>
    )
  }

}

export default Iframe;